import { replace, useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { Image, Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import SessionUtil from "../util/SessionUtil";

function ListGroup() {
  const storedType = SessionUtil.getTypeUser();
  const { t } = useTranslation();
  const [active, setActive] = useState("/driver-list");
  const location = useLocation();
  const navigate = useNavigate();

  // Set active state based on the current location
  useEffect(() => {
    setActive(location.pathname);
  }, [location]);

  const handleClickNav = (url) => {
    setActive(url);
    navigate(url, replace); // Navigates to the clicked URL
  };

  const list = [
    { id: 1, link: "/driver-list", name: t("Driver List"), type: ["2", "4"] },
    {
      id: 2,
      link: "/live-driver-list",
      name: t("Live Driver List"),
      type: ["4"],
    },
    { id: 3, link: "/operation", name: t("Operations"), type: ["1"] },
    { id: 4, link: "/stores-list", name: t("Stores List"), type: ["2", "4"] },
    {
      id: 5,
      link: "/driver-registration-request",
      name: t("Driver Registration request"),
      type: ["4"],
    },
    {
      id: 6,
      link: "/link-driver",
      name: t("Link driver with operation"),
      type: ["4"],
    },
    { id: 7, link: "/Orders-pending", name: t("Orders Pending"), type: ["4"] },
    { id: 8, link: "/contact-us", name: t("Contact us"), type: ["4"] },
    {
      id: 9,
      link: "/terms-conditions",
      name: t("create terms and conditions"),
      type: ["4"],
    },
  ];

  return (
    <Nav
      className="list-group-custome mt-5 p-0"
      defaultActiveKey="/driver-list"
    >
      {list.map((item, index) => {
        return (
          item.type.includes(storedType) && (
            <Nav.Item
              key={index}
              className={`mb-2 ${active === item.link ? "active" : ""}`}
              onClick={() => (item.link === "/driver-list" || item.link === "/stores-list") &&  handleClickNav(item.link)}
            >
              <Nav.Link
                onClick={() => handleClickNav(item.link)}
                eventKey={item.link}
                className="text-capitalize"
              >
                {active === item.link && (
                  <Image alt="image" src="/images/fire.png" width={18} />
                )}
                {item.name}
              </Nav.Link>
            </Nav.Item>
          )
        );
      })}
    </Nav>
  );
}

export default ListGroup;
